// Generated by tools/gen-backend-hooks.ts — do not edit by hand.
// One hook per endpoint in backend/stockStation/.

import { makeBackendHook } from './_client'

export type { BackendQuery, TriggerOptions } from './_client'

/** POST /api/rpc/stockStation/getStockStation */
export const useGetStockStation = makeBackendHook('stockStation', 'getStockStation')

/** POST /api/rpc/stockStation/saveStockStation */
export const useSaveStockStation = makeBackendHook('stockStation', 'saveStockStation')

/** POST /api/rpc/stockStation/setStockStationPhotos */
export const useSetStockStationPhotos = makeBackendHook('stockStation', 'setStockStationPhotos')
